import React, { useContext, useMemo } from 'react'
import PropTypes from 'prop-types'
import { endOfDay, startOfDay } from 'date-fns'

import { MediaOrderFormContext } from '../../../../../../../../../../../MediaOrderFormContext'
import { ProductsCalendarProvider } from '../../../../../../../../../../../../../../pages/Proposals/ProductsCalendarPreview/ProductsCalendarContext'
import ProductsCalendarPreview from '../../../../../../../../../../../../../../pages/Proposals/ProductsCalendarPreview'

import useStyles from '../styles'

const ProductBookingsCalendar = ({ bookedMedias, productData, dateRange }) => {
  const classes = useStyles()

  const { currency } = useContext(MediaOrderFormContext)

  const calendar = useMemo(() => {
    // the calendar date range should be strict to the selected bookings DateRange
    const calendarDates = {
      earliestDate: dateRange.startDate,
      latestDate: dateRange.endDate
    }

    const formattedProductBookings = bookedMedias?.map(booking => {
      const startDate = new Date(booking.date_start)
      const endDate = new Date(booking.date_end)

      return {
        ...booking,
        currency,
        start_timestamp: +startOfDay(startDate), // use timestamps instead of dates
        // take the full end date (end of the day) to show the event on the full day
        end_timestamp: +endOfDay(endDate) //  use timestamps instead of dates
      }
    })

    return {
      ...calendarDates,
      products: [
        {
          group: {
            id: productData.id,
            name: productData?.name,
            asset_id: productData?.internal_id
          },
          events: formattedProductBookings
        }
      ]
    }
  }, [
    bookedMedias,
    currency,
    dateRange.endDate,
    dateRange.startDate,
    productData.id,
    productData?.internal_id,
    productData?.name
  ])

  return (
    <ProductsCalendarProvider calendar={calendar} hasMarginOnSides={false} eventLabelAsDate={false}>
      <ProductsCalendarPreview
        products={calendar.products}
        showProductCols={false}
        className={classes.calendarPreview}
      />
    </ProductsCalendarProvider>
  )
}

ProductBookingsCalendar.propTypes = {
  bookedMedias: PropTypes.array.isRequired,
  productData: PropTypes.object.isRequired,
  dateRange: PropTypes.object.isRequired
}

export default ProductBookingsCalendar
